@use "../../styling/colors.scss" as *;

.CustomRow {
  &[aria-selected="true"],
  &.isExpanded {
    background: $theme-color-sub-background;
  }

  a {
    color: $theme-color-links;
  }

  &.isExpanded {
    border-color: $color-primary-purple;
    border-width: 2px 2px 0;
    border-style: solid;

    + tr {
      border-color: $color-primary-purple;
      border-width: 0 2px 2px;
      border-style: solid;
    }
  }
}
